import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

const NotificationDeleteModal = ({
    isOpen,
    title,
    toggle,
    onDelete,
    isInSendingWindow,
    afterSendingWindow,
}) => {
    const defaultText = (
        <p>
            Are you sure that you want to delete the <strong>{title}</strong>{" "}
            notification and all its data?
        </p>
    )
    let text = defaultText
    let extraText = null
    if (isInSendingWindow) {
        text = (
            <p>
                The <strong>{title}</strong> notification is currently being
                sent and <strong>can't be interrupted</strong>. Please try again
                later.
            </p>
        )
    } else if (afterSendingWindow) {
        extraText = (
            <p>
                This notification has already been sent and{" "}
                <strong>cannot be undone</strong>. Deleting it will only remove
                it from this list.
            </p>
        )
    } else {
        extraText = (
            <p>
                This will <strong>prevent</strong> the notification from being
                sent.
            </p>
        )
    }
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className="modal-dialog-v-centered modal-horizontally-centered"
        >
            <ModalHeader>Delete Notification</ModalHeader>
            <ModalBody>
                {text}
                {extraText}
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-cancel col" onClick={toggle}>
                    Cancel
                </button>
                {!isInSendingWindow ? (
                    <button className="btn btn-primary col" onClick={onDelete}>
                        Delete {afterSendingWindow ? "anyway" : null}
                    </button>
                ) : null}
            </ModalFooter>
        </Modal>
    )
}

export default NotificationDeleteModal
